const i = (i2, o) => [i2.slice(0, o).join(""), i2.slice(o).join("")].join(".");
export {
  i as getCurrentReadingValue
};
//# sourceMappingURL=getCurrentReadingValue.js.map
